module.exports = __webpack_public_path__ + "static/scheduler-background-4e9647439675e44a754fec8f5095f897.png";